export interface ClientName {
  firstName: string;
  lastName: string;
  middleName: string;
  prefixName: string;
  suffixName: string;
}

export interface TelephoneNumber {
  areaCode: string;
  countryCode: string;
  extensionNumber: number;
  phoneNumber: string;
}

export interface Address {
  city: string;
  countryCode: string;
  postalCode: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  state: string;
}

export interface Balance {
  points: number;
  conversionRate: number;
  isRedemptionAllowed: boolean;
}

export enum AddressLevelType {
  CustomerPrimary = 'CustomerPrimary',
  AccountPrimary = 'AccountPrimary',
  AccountOther = 'AccountOther',
  Agent = 'Agent',
  Other = 'Other',
}

export interface UserAddress {
  addressCityName: string;
  addressCountryCode: string;
  addressCountryName: string;
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  addressPostalCode: string;
  addressStateName: string;
  addressStateCode: string;
  badAddressIndicator: boolean;
  nonResidentialAddressIndicator: boolean;
  addressUsageLevelText: AddressLevelType;
}

export interface User {
  accountId: string;
  name: ClientName;
  isDisplayNameSubstituted?: boolean;
  telephoneNumber: TelephoneNumber;
  emailAddress: string;
  balance: Balance;
  isValidAddress: boolean;
  rpcCode?: string;
  disablePointsAccelerator?: boolean;
  addresses: UserAddress[];
}
